import { Component, EventEmitter, OnInit, Output, Input, ViewChild } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
import { ASCIIPipe } from "../../../../../projects/jv-common/src/lib/common/ascii.pipe";
import { VOC, VOCType, TargetAccount, BankingService } from '../../../../../projects/accounting/src/public_api';
import { SelectDropDownComponent } from 'ngx-select-dropdown';

export interface VOCEditorData {
  info: VOC;
  accounts?: Array<TargetAccount>
}

@Component({
  selector: 'voc-editor',
  templateUrl: './voc-editor.component.html',
  styleUrls: ['./voc-editor.component.scss']
})
export class VOCEditorComponent implements OnInit {

  @Input() data: VOCEditorData;
  @Output() change = new EventEmitter<VOCEditorData>();

  selectedBranch: string;
  selectedBank: string;

  @ViewChild('bank')
  private bankComponent: SelectDropDownComponent;

  @ViewChild('branch')
  private branchComponent: SelectDropDownComponent;

  banks = [];
  branches = [];

  bankLU = {};
  error = '';

  configs = {
    bank: {
      search: true,
      height: 'auto',
      placeholder: 'Chọn ngân hàng',
      noResultsFound: 'Không có kết quả nào!',
      searchPlaceholder: 'Tìm kiếm'
    },

    branch: {
      search: true,
      height: 'auto',
      placeholder: 'Chọn chi nhánh',
      noResultsFound: 'Không có kết quả nào!',
      searchPlaceholder: 'Tìm kiếm'
    }
  };

  accountIndex = 0;

  constructor(
    public modalRef: BsModalRef,
    private ascii: ASCIIPipe,
    private banking: BankingService) {
  }


  ngOnInit() {

    if (typeof this.data.accounts == "undefined" || this.data.accounts == null) this.data.accounts = [];

    let buffer: any;

    // clone data to ensure editting opeation will not affect the source data
    buffer = [];
    this.data.accounts.forEach(account => {

      let buffer2 = {};
      for (let o in account) buffer2[o] = account[o];

      buffer.push(buffer2);
    });

    this.data.accounts = buffer;

    buffer = {};
    for (let o in this.data.info) buffer[o] = this.data.info[o];
    this.data.info = buffer;


    // initialise bank information for vendor
    if (this.data.info.type == VOCType.vendor) {

      this.bankLU = {};

      this.banking.data().forEach(i => {
        this.bankLU[i.bank] = i;
        this.banks.push(i.bank);
      });

      this.select(0);
    }
  }


  isCash() {
    return this.data.info.type == VOCType.customer || this.data.accounts[this.accountIndex].globalBankName == "TIỀN MẶT";
  }

  emit() {

    this.change.emit(this.data);
    this.modalRef.hide();
  }

  delete() {

    if (this.data.info.type == VOCType.customer) return;

    let current = this.data.accounts[this.accountIndex];
    this.select(0);

    this.data.accounts = this.data.accounts.filter(i => i != current);
  }

  add() {

    if (this.data.info.type == VOCType.customer) return;

    this.data.accounts.push({
      name: '',
      account: '',
      owner: '',
      globalBankName: '',
      globalBranchName: ''
    });

    this.select(this.data.accounts.length - 1);
  }

  select(index) {

    if (this.data.info.type == VOCType.customer) return;

    this.accountIndex = index;

    this.branches = typeof this.bankLU[this.selectedBank] == "undefined" ? [] : this.bankLU[this.selectedBank].branches;

    if (typeof this.bankComponent != "undefined") {

      this.bankComponent.selectItem(this.data.accounts[index].globalBankName);
    }
    else {
      this.selectedBank = this.data.accounts[index].globalBankName;
      this.selectedBranch = this.data.accounts[index].globalBranchName;
    }
  }

  updateBank() {

    if (this.data.info.type == VOCType.customer) return;

    let current = this.data.accounts[this.accountIndex];

    if (typeof this.selectedBank == "string") {
      current.globalBankName = this.selectedBank;
    }

    if (typeof this.bankLU[current.globalBankName] == 'undefined') {
      current.globalBankName = current.globalBranchName = '';

      this.branches = [];
      this.selectedBranch = '';
    }
    else {

      this.branches = this.bankLU[current.globalBankName].branches;
      this.selectedBranch = this.branches.indexOf(current.globalBranchName) < 0 ? '' : current.globalBranchName;
    }
  }

  updateBranch() {

    if (this.data.info.type == VOCType.customer) return;

    let current = this.data.accounts[this.accountIndex];

    if (this.branchComponent.selectedItems.length == 1) {

      current.globalBranchName = this.branches.indexOf(this.selectedBranch) < 0 ? '' : this.selectedBranch;
    }
  }
}
